// roles.service.ts
import { Injectable, Signal, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private userRoles = new BehaviorSubject<string[]>([]);
  userRoles$ = this.userRoles.asObservable();

  private userRole = signal<string[]>([]);

 // Update user roles
  updateRoles(roles: string[]) {
    this.userRoles.next(roles);
  }

  // Set user roles (call this after fetching user roles)
  setUserRoles(roles: string[]) {
    this.userRole.set(roles);
  }

  // Check if the user has a specific role
  hasRole(role: string): boolean {
    return this.userRole().includes(role);
  }

  // Check if the user has at least one role from the given list
  hasAnyRole(roles: string[]): boolean {
    return roles.some(role => this.userRole().includes(role));
  }
}
